import { render, staticRenderFns } from "./SpecificationInvoicing.vue?vue&type=template&id=5c8faee0"
import script from "./SpecificationInvoicing.vue?vue&type=script&lang=js"
export * from "./SpecificationInvoicing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports